import { styled, Tabs } from '@mui/material';

export const BottomFilterDiv = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
}));

export const MyTabs = styled(Tabs)(({ theme }) => ({
    minHeight: 'auto',
    '& .MuiTabs-flexContainer': {
        alignItems: 'center',
        columnGap: theme.spacing(2),
        flexWrap: 'wrap',
    },
    '& .MuiTab-root': {
        minHeight: 'auto',
        padding: theme.spacing(0.5, 0),
        marginLeft: theme.spacing(0.1),
        textTransform: 'none',
        minWidth: 'auto',
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: 1.5,
        letterSpacing: '0.00938em',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&.Mui-selected': {
            backgroundColor: 'transparent',
        },
    },
}));
